export default __webpack_public_path__ + "static/media/ep8.7f84421c.jpeg";